import React from "react";
import Modal from "./Modal";

const DisconnectModal = ({ isVisible, onCancel, onDisconnect }) => {
  const handleDisConnect = () => {
    onDisconnect();
    onCancel();
  };

  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="disconnect-modal card px-3 py-4"
    >
      <div className="heading">
        <h4 className="mb-1">Disconnect your wallet</h4>
        <p className="text pt-3">
          Please confirm to disconnect your <strong>wallet</strong>.
        </p>
        <div className="body d-flex justify-content-center pt-4 me-4">
          <button
            className="btn btn-primary continue"
            onClick={handleDisConnect}
          >
            Confirm
          </button>
          <button
            className="btn btn-outline-secondary mx-2 close"
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DisconnectModal;
